import { atomWithQuery } from "jotai-tanstack-query";
import { authAtom } from "../auth/atoms"; // Import authAtom
import { getAllSavedPlaces } from "../../apis";

export const userSavedPlacesAtom = atomWithQuery((get) => {
  // 1. Get the current auth state
  const authState = get(authAtom);
  const user = authState.data;

  return {
    // 2. Add user.id to the key. 
    // If user becomes null (logout), the key changes, resetting the state.
    // If user A logs out and user B logs in, the cache is separated.
    queryKey: ["getAllSavedPlaces", user?.id], 
    
    queryFn: async () => {
      // 3. Use the token from the atom, not Storage directly (cleaner dependency)
      if (!user?.accessToken) return null;
      
      const savedPlaces = await getAllSavedPlaces(user.accessToken);
      return savedPlaces;
    },
    
    // 4. Disable the query if there is no user logged in
    enabled: !!user, 
  };
});